import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../../firebase';
import "../../App.css";
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore'

export default function Labourcat() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [staffcats, setstaffcats] = useState([]);
    const [searchText, setsearchText] = useState("");

    const [staffcat, setstaffcat] = useState("");

    const [updocid, setupdocid] = useState("");
    const [upstaffcat, setupstaffcat] = useState("");

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData) {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    fetchData1();
                    setloadincount(false)
                }
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'staffcats'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setstaffcats(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = staffcats.filter((item) =>
                item.data.staffcat.toUpperCase().includes(searchText.toUpperCase())
            );
            setstaffcats(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }



    const handleSubmit = async () => {
        if (!staffcat) {
            Toast.fire({
                icon: "error",
                title: 'Please Enter Required Fields!!'
            });

            return;
        }

        try {

            await addDoc(collection(db, "staffcats"), {
                staffcat: staffcat,
                uid: userData.uid,
                createdAt: Timestamp.now(),
            });

            setstaffcat("");
            fetchData1();

            Toast.fire({
                icon: "success",
                title: 'staff Category Added Successfully!!'
            });


        } catch (err) {
            Toast.fire({
                icon: "error",
                title: 'Error in Image Uploading!!'
            });
        }
    }

    const handleDelete = async (docid) => {
        const taskDocRef = doc(db, 'staffcats', docid)
        await deleteDoc(taskDocRef)

        Toast.fire({
            icon: "success",
            title: 'staff Category Deleted Successfully!!'
        });
        fetchData1();
    }

    const handleEdit = (id, staffcat) => {
        setupdocid(id);
        setupstaffcat(staffcat);
    }

    const handleUpdate = async () => {
        if (!upstaffcat) {
            Toast.fire({
                icon: "error",
                title: 'Please Enter Required Fields!!'
            });
            return;
        }

        await updateDoc(doc(db, "staffcats", updocid), {
            staffcat: upstaffcat,
        });
        Toast.fire({
            icon: "success",
            title: 'staff Category Updated Successfully!!'
        });

        fetchData1();
    }


    return (
        <div>
            <div className="content-wrapper">
                <br />

                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Staff Category  Mgmt ||</button>
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Staff Category</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >

                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>staff Category </th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            staffcats.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.data.staffcat}</td>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.staffcat)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}

            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Staff Category</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Staff Category *</label>
                                    <input type="text" value={staffcat} onChange={(e) => setstaffcat(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Staff Category</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>  Staff Category *</label>
                                    <input type="text" value={upstaffcat} onChange={(e) => setupstaffcat(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
